export default __webpack_public_path__ + "static/media/breakfast2.659ea007.png";